"use strict";

jQuery( function ($) {


    // trigger page view
    if ($('[data-trigger-pageview]').length) {
        $.ajax({
            url: themevars.ajaxurl,
            data: {
                action: 'count_page_view',
                post_id: themevars.post_id,
                nonce: themevars.nonce
            },
            type: 'POST',
            dataType: 'json'
        }).done(function (result) {
            // page view count is done in PHP
        });
    }
});